/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.64"
        height="95.58"
        viewBox="0 0 79.64 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M38.99.32C28.76 9.5 16.56 14.07 1.21 14.5A1.25 1.25 0 0 0 0 15.75v15.24c0 3 .06 5.89.2 8.61l.08 1.47c.64 10.43 2.44 18.76 6 26.45 6 12.67 16.55 22 33.08 28a1.21 1.21 0 0 0 .84 0c16.53-5.94 27.14-15.32 33.08-28 4.69-10 6.32-21.12 6.32-36.53V15.78a1.25 1.25 0 0 0-1.17-1.28c-15.35-.43-27.55-5-37.77-14.18a1.24 1.24 0 0 0-1.67 0Zm.83 2.59.17.15c10.13 8.7 22.14 13.21 36.88 13.91h.27v14c0 15.07-1.58 25.86-6.09 35.47l-.24.51c-5.62 11.63-15.44 20.3-30.73 25.94l-.26.09.42.16c-15.91-5.7-26-14.64-31.65-26.64l-.25-.53C4.02 56.5 2.5 45.79 2.5 30.99v-14h.27c14.73-.72 26.73-5.23 36.88-13.93Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M39.71 65.57h6.79a1.33 1.33 0 0 0 1.33-1.33 1.09 1.09 0 0 0 0-.26l-3.89-16.9a1 1 0 0 1 0-.24 1.16 1.16 0 0 1 .53-1 8.58 8.58 0 1 0-9.05 0 1.17 1.17 0 0 1 .52 1 1.94 1.94 0 0 1 0 .24l-3.9 16.9a1.09 1.09 0 0 0 0 .26 1.33 1.33 0 0 0 1.33 1.33Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M39.84 29.26a9.32 9.32 0 0 0-4.92 17.24.39.39 0 0 1 .17.34.28.28 0 0 1 0 .09l-3.9 16.88a2.18 2.18 0 0 0 0 .43 2.08 2.08 0 0 0 2.08 2.08H46.5a2.08 2.08 0 0 0 2-2.08 1.9 1.9 0 0 0 0-.41l-3.9-16.92v-.07a.41.41 0 0 1 .18-.35 9.32 9.32 0 0 0-4.93-17.23Zm0 1.5a7.82 7.82 0 0 1 4.13 14.46 1.93 1.93 0 0 0-.88 1.62 2.33 2.33 0 0 0 0 .38l3.9 16.92v.1a.58.58 0 0 1-.58.58H33.22a.58.58 0 0 1-.58-.58s0-.08 0-.11l3.9-16.88a2 2 0 0 0 0-.41 1.91 1.91 0 0 0-.87-1.61 7.82 7.82 0 0 1 4.12-14.47Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithKeyholeIcon';

export default Icon;
